import React from 'react';

export const LanguageCountryCode = React.createContext('de-DE');
